
import React from "react";
import { 
  Card, 
  CardContent, 
  CardHeader, 
  CardTitle, 
  CardDescription 
} from "@/components/ui/card";
import { Languages } from "lucide-react";
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend, 
  ResponsiveContainer,
  Cell
} from "recharts";

// Language distribution colors
const LANGUAGE_COLORS = [
  "#FF6B6B", "#4ECDC4", "#FFD166", "#06D6A0", "#118AB2", 
  "#073B4C", "#9A8C98", "#F4A261", "#E76F51", "#2A9D8F"
];

interface LanguageDistributionChartProps {
  languageDistribution: {
    language: string;
    count: number;
  }[];
}

const LanguageDistributionChart = ({ languageDistribution }: LanguageDistributionChartProps) => {
  // Process data to ensure all language entries have labels
  const processedData = languageDistribution.map(item => {
    return {
      language: item.language || "Not Specified",
      count: item.count
    };
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Languages className="mr-2 h-5 w-5 text-[#333B44]" />
          Language Distribution
        </CardTitle>
        <CardDescription>
          Languages spoken by users (primary + secondary combined)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={processedData}
              layout="vertical"
              margin={{
                top: 20,
                right: 30,
                left: 80,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" tickFormatter={(value) => Math.round(value).toString()} />
              <YAxis dataKey="language" type="category" width={80} />
              <Tooltip formatter={(value) => [Math.round(Number(value)), ""]} />
              <Legend verticalAlign="top" height={36} formatter={(value) => value} />
              <Bar dataKey="count" name="Users">
                {processedData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={LANGUAGE_COLORS[index % LANGUAGE_COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default LanguageDistributionChart;
